import { render } from "./ChangeAuth0Email.vue?vue&type=template&id=09e51f16"
import script from "./ChangeAuth0Email.vue?vue&type=script&lang=js"
export * from "./ChangeAuth0Email.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__